import { FunctionComponent, useMemo } from "react";
import { sanitize } from "isomorphic-dompurify";

interface Props {
  html?: string;
  id?: string;
  Component?: "span" | "div";
}

const HTMLRichText: FunctionComponent<Props> = ({
  html,
  id,
  Component = "div",
}) => {
  const sanatizedHtml = useMemo(
    () => sanitize(html || "", { ADD_ATTR: ["target"] }),
    [html],
  );

  if (!sanatizedHtml) {
    return null;
  }

  return (
    <Component
      id={id}
      dangerouslySetInnerHTML={{
        __html: sanatizedHtml,
      }}
    />
  );
};

export default HTMLRichText;
